export abstract class FinessHelper {
	//#region METHODS

	public static isValid(psFinessNumber: string): boolean {
		return /^[0-9]{1}[0-9a-zA-Z]{1}[0-9]{7}$/.test(psFinessNumber);
	}

	//#endregion
}
